import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { ZoomSettings } from './ZoomSettings'

export const ZoomSpecificSettings = (): ClickNavigationProps[] => {
  return [{ id: 'settings', label: 'Zoom Settings', content: () => <ZoomSettings /> }]
}
